import { render, staticRenderFns } from "./CRUDTable3.vue?vue&type=template&id=20593715"
import script from "./CRUDTable3.vue?vue&type=script&lang=js"
export * from "./CRUDTable3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports